import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select, Upload } from "antd";
import { DataType } from "components/Tables/FormDesignTable/temp";
import { GeneralFormProvider } from "components/UI/GeneralForm/GeneralFormProvider";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";

import { FormDesignPreviewEditFormData, schema } from "./formSchema";

interface FormDesignPreviewEditFormProps {
    formData: DataType;
    onUpdate: (newData: DataType) => void;
}

const FormDesignPreviewEditFormContent: FC<{ onSubmit: (values: DataType) => void; formData: DataType }> = ({
    onSubmit,
    formData,
}) => {
    const { t } = usePaldockTranslation("forms.form-design-preview");
    const { t: tC } = usePaldockTranslation("common");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm<FormDesignPreviewEditFormData>();
    const { control, fieldNames, handleSubmit } = generalFormUtils;

    const onSubmitForm = (values: FormDesignPreviewEditFormData) => {
        onSubmit({
            ...formData,
            ...values,
        });
    };

    return (
        <Row gutter={16}>
            <Col span={24}>
                <FormItem control={control} name={fieldNames.company?.name || "company"} label={t("fields.company.label")} required>
                    <Input placeholder={t("fields.company.placeholder")} />
                </FormItem>
            </Col>
            <Col span={24}>
                <FormItem control={control} name={fieldNames.logo?.name || "logo"} label={t("fields.logo.label")}>
                    <Upload>
                        <Button icon={<UploadOutlined />}>{t("actions.upload_logo")}</Button>
                    </Upload>
                </FormItem>
            </Col>
            <Col span={24}>
                <FormItem control={control} name={fieldNames.fee?.name || "fee"} label={t("fields.fee.label")}>
                    <Input placeholder={t("fields.fee.placeholder")} />
                </FormItem>
            </Col>
            <Col span={24}>
                <FormItem control={control} name={fieldNames.status?.name || "status"} label={tFields("status.label")} required>
                    <Select placeholder={tFields("status.placeholder")}>
                        <Select.Option value="active">{tC("active")}</Select.Option>
                        <Select.Option value="inactive">{tC("inactive")}</Select.Option>
                    </Select>
                </FormItem>
            </Col>
            <Col span={24}>
                <FormItem
                    control={control}
                    name={fieldNames.approvalProbability?.name || "approvalProbability"}
                    label={t("fields.approval_probability.label")}
                >
                    <Input placeholder={t("fields.approval_probability.placeholder")} />
                </FormItem>
            </Col>
            <Col span={24}>
                <FormItem control={control} name={fieldNames.link?.name || "link"} label={t("fields.link.label")}>
                    <Input placeholder={t("fields.link.placeholder")} />
                </FormItem>
            </Col>
            <Col span={24}>
                <Row justify="end" gutter={16}>
                    <Col>
                        <Button type="default">{tC("cancel")}</Button>
                    </Col>
                    <Col>
                        <Button type="primary" htmlType="submit" onClick={handleSubmit(onSubmitForm)}>
                            {tC("save")}
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export const FormDesignPreviewEditForm: FC<FormDesignPreviewEditFormProps> = ({ formData, onUpdate }) => {
    return (
        <GeneralFormProvider<FormDesignPreviewEditFormData> schema={schema} defaultValues={formData}>
            <FormDesignPreviewEditFormContent formData={formData} onSubmit={onUpdate} />
        </GeneralFormProvider>
    );
};
